'use client'

import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { Icons } from '@/components/ui/icons'

interface Capability {
  icon: React.ElementType
  label: string
  query: string
}

const CAPABILITIES: Capability[] = [
  { icon: Icons.clipboardList, label: 'Create a purchase request', query: 'I need to create a new purchase request' },
  { icon: Icons.users, label: 'Show vendor list', query: 'Show me all available vendors' },
  { icon: Icons.search, label: 'Find a vendor', query: 'I need vendor recommendations for laptops' },
  { icon: Icons.layers, label: 'List purchase requests', query: 'Show me all purchase requests' },
  { icon: Icons.barChart, label: 'Check department budget', query: 'Check budget availability for Engineering department for $50,000' },
  { icon: Icons.sparkles, label: 'Run vendor due diligence', query: 'Run due diligence on a vendor' },
]

interface CapabilityBubblesProps {
  onSelect: (query: string) => void
}

export function CapabilityBubbles({ onSelect }: CapabilityBubblesProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2 p-2">
      {CAPABILITIES.map((cap, i) => {
        const Icon = cap.icon
        return (
          <motion.button
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06, duration: 0.25, ease: 'easeOut' }}
            onClick={() => onSelect(cap.query)}
            className={cn(
              'flex items-center gap-2 px-3 py-2 rounded-full',
              'bg-white border border-brand-cornflower/20',
              'text-sm text-brand-navy',
              'shadow-sm',
              'transition-all duration-200',
              'hover:bg-brand-cornflower/10 hover:border-brand-cornflower/40 hover:shadow-md',
              'focus:outline-none focus:ring-2 focus:ring-brand-cornflower/50'
            )}
          >
            <Icon className="h-4 w-4 text-brand-cornflower" strokeWidth={1.5} />
            <span className="text-xs sm:text-sm font-medium">{cap.label}</span>
          </motion.button>
        )
      })}
    </div>
  )
}
